<template>
  <div class="reports flex flex-col p-8">
    <ReportsFilters />
    <ReportsTable />
  </div>
</template>

<script>
import ReportsFilters from './ReportsFilters'
import ReportsTable from './ReportsTable'

export default {
  name: 'Reports',
  components: {
    ReportsFilters,
    ReportsTable
  }
}
</script>
